/**
 * @generated SignedSource<<2187a9422c41e11521ed0d2b3146e931>>
 * @relayHash 8ae794812076dcc268ac624e46beef8b
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-trade/514.0.0-2025-06-10T15:56:24.020Z/RenderItemEmailMutation

import { ConcreteRequest } from 'relay-runtime';
export type RenderItemEmailInput = {
  captchaToken?: string | null;
  clientMutationId?: string | null;
  itemId: string;
  message?: string | null;
  recipientEmails: ReadonlyArray<string | null>;
  senderEmail: string;
  senderName: string;
  skuId?: string | null;
};
export type RenderItemEmailMutation$variables = {
  input: RenderItemEmailInput;
};
export type RenderItemEmailMutation$data = {
  readonly renderItemEmail: {
    readonly clientMutationId: string | null;
  } | null;
};
export type RenderItemEmailMutation = {
  response: RenderItemEmailMutation$data;
  variables: RenderItemEmailMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RenderItemEmailPayload",
    "kind": "LinkedField",
    "name": "renderItemEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RenderItemEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RenderItemEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-trade/514.0.0-2025-06-10T15:56:24.020Z/RenderItemEmailMutation",
    "metadata": {},
    "name": "RenderItemEmailMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c58daa30a2a98ff34ccaa9b704be671d";

export default node;
